import { call, put } from 'redux-saga/effects'

import * as types from '../actions/actionTypes'
import { setSnackbarErrorAction } from '../actions/snackbarActions'
import * as api from '../api'
import { getErrorMessage } from '../domain/Errno'

export function* getItemEntryInfoSaga({ payload: itemId }) {
  try {
    yield put({ type: types.FETCHING })
    const res = yield call(api.requestGetItemEntryInfo, itemId)
    yield put({
      type: types.GET_ITEM_ENTRY_INFO_SUCCESS,
      payload: {
        ...res.data,
        cream_item_id: itemId,
      },
    })
  } catch (err) {
    console.error('getItemEntryInfoSaga', err)
    yield put({ type: types.GET_ITEM_ENTRY_INFO_ERROR })
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

export function* getBuyerInstalmentsInfoSaga({ payload: periodId }) {
  try {
    yield put({ type: types.FETCHING })
    const res = yield call(api.requestGetBuyerInstalmentsInfo, periodId)
    yield put({
      type: types.GET_BUYER_INSTALMENTS_INFO_SUCCESS,
      payload: {
        ...res.data,
        period_id: periodId,
      },
    })
  } catch (err) {
    console.error('getBuyerInstalmentsInfoSaga', err)
    yield put({ type: types.GET_BUYER_INSTALMENTS_INFO_ERROR })
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

export function* getBuyerPeriodicInfoSaga({ payload: orderNo }) {
  try {
    yield put({ type: types.FETCHING })
    const res = yield call(api.requestGetBuyerPeriodicInfo, orderNo)
    yield put({
      type: types.GET_BUYER_PERIODIC_INFO_SUCCESS,
      payload: {
        order_no: orderNo,
        status: 'created',
        ...res.data,
      },
    })
  } catch (err) {
    if (err?.data?.errno) {
      yield put(setSnackbarErrorAction(getErrorMessage(err)))
    }
    console.error('getBuyerPeriodicInfoSaga', err)
    yield put({ type: types.GET_BUYER_PERIODIC_INFO_ERROR })
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}
